import * as React from "react";
const SvgFiRrFaceGrinTongueWink = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-grin-tongue-wink_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m4-8H8a1 1 0 1 0 0 2h1v.6c0 1.636 1.147 3.4 3 3.4s3-1.765 3-3.4V16h1a1 1 0 1 0 0-2m-3 2.6c0 .662-.411 1.4-1 1.4s-1-.738-1-1.4V16h2zM15.5 6C13.57 6 12 7.57 12 9.5s1.57 3.5 3.5 3.5S19 11.43 19 9.5 17.43 6 15.5 6m0 5c-.827 0-1.5-.673-1.5-1.5S14.673 8 15.5 8s1.5.673 1.5 1.5-.673 1.5-1.5 1.5m-7.256-.349C7.895 10.249 7.4 10 6.95 10h-.007q-.64.005-1.18.643a1.001 1.001 0 0 1-1.528-1.292c.938-1.108 1.983-1.346 2.695-1.35a3.93 3.93 0 0 1 2.824 1.341 1.001 1.001 0 0 1-1.512 1.31z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-grin-tongue-wink_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceGrinTongueWink;
